import { render, staticRenderFns } from "./EcoPartPrivateCopying.vue?vue&type=template&id=cdd81724&"
import script from "./EcoPartPrivateCopying.vue?vue&type=script&lang=js&"
export * from "./EcoPartPrivateCopying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdd81724')) {
      api.createRecord('cdd81724', component.options)
    } else {
      api.reload('cdd81724', component.options)
    }
    module.hot.accept("./EcoPartPrivateCopying.vue?vue&type=template&id=cdd81724&", function () {
      api.rerender('cdd81724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/EcoPartPrivateCopying.vue"
export default component.exports